import { useState } from 'react';
import { Link } from 'react-router-dom';

export function SignIn() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        // TODO: Implement authentication logic
        console.log('Sign in with:', { email, password, rememberMe });
        setTimeout(() => setIsLoading(false), 1000);
    };

    const handleGoogleSignIn = () => {
        // TODO: Implement Google OAuth
        console.log('Sign in with Google');
    };

    const handleGitHubSignIn = () => {
        // TODO: Implement GitHub OAuth
        console.log('Sign in with GitHub');
    };

    return (
        <div className="min-h-screen bg-white flex">
            {/* Left Side - Branding */}
            <div className="hidden lg:flex lg:w-1/2 bg-brand-slate relative overflow-hidden">
                <div className="absolute inset-0 light-cinematic-gradient opacity-20"></div>
                <div className="relative z-10 flex flex-col justify-center px-16 text-white">
                    <Link to="/" className="flex items-center gap-3 mb-12">
                        <svg className="h-10 w-10 text-brand-blue" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="100" cy="100" r="90" fill="currentColor" stroke="none" />
                            <path d="M75 100a25 25 0 0 1 50 0h25a50 50 0 1 0-50 50v-25a25 25 0 0 1-25-25z" fill="white" transform="rotate(-40 100 100)" />
                            <rect x="135" y="100" width="10" height="15" rx="6" fill="white" />
                            <rect x="160" y="94" width="10" height="30" rx="6" fill="white" />
                        </svg>
                        <span className="text-2xl font-extrabold tracking-tight uppercase italic">ConnectHID</span>
                    </Link>
                    <h1 className="text-5xl font-extrabold mb-6 leading-tight">
                        Welcome back to<br />unified control.
                    </h1>
                    <p className="text-xl text-white/80 leading-relaxed">
                        Sign in to access your devices, workflows, and integrations across mobile, web, and IDE.
                    </p>
                </div>
            </div>

            {/* Right Side - Sign In Form */}
            <div className="flex-1 flex items-center justify-center px-6 py-12">
                <div className="w-full max-w-md">
                    {/* Mobile Logo */}
                    <Link to="/" className="lg:hidden flex items-center gap-2 mb-8">
                        <svg className="h-8 w-8 text-brand-blue" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="100" cy="100" r="90" fill="currentColor" stroke="none" />
                            <path d="M75 100a25 25 0 0 1 50 0h25a50 50 0 1 0-50 50v-25a25 25 0 0 1-25-25z" fill="white" transform="rotate(-40 100 100)" />
                            <rect x="135" y="100" width="10" height="15" rx="6" fill="white" />
                            <rect x="160" y="94" width="10" height="30" rx="6" fill="white" />
                        </svg>
                        <span className="text-xl font-extrabold tracking-tight text-brand-slate uppercase italic">ConnectHID</span>
                    </Link>

                    <div className="mb-8">
                        <h2 className="text-3xl font-bold text-brand-slate mb-2">Sign in to your account</h2>
                        <p className="text-slate-500">
                            Don't have an account?{' '}
                            <Link to="/signup" className="text-brand-blue font-semibold hover:underline">
                                Sign up
                            </Link>
                        </p>
                    </div>

                    {/* OAuth Buttons */}
                    <div className="space-y-3 mb-6">
                        <button
                            onClick={handleGoogleSignIn}
                            className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-brand-border rounded-lg hover:bg-brand-gray transition-colors font-medium text-brand-slate"
                        >
                            <svg className="w-5 h-5" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                            </svg>
                            Continue with Google
                        </button>
                        <button
                            onClick={handleGitHubSignIn}
                            className="w-full flex items-center justify-center gap-3 px-4 py-3 border border-brand-border rounded-lg hover:bg-brand-gray transition-colors font-medium text-brand-slate"
                        >
                            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" />
                            </svg>
                            Continue with GitHub
                        </button>
                    </div>

                    {/* Divider */}
                    <div className="relative mb-6">
                        <div className="absolute inset-0 flex items-center">
                            <div className="w-full border-t border-brand-border"></div>
                        </div>
                        <div className="relative flex justify-center text-sm">
                            <span className="px-4 bg-white text-slate-500 font-medium">Or continue with email</span>
                        </div>
                    </div>

                    {/* Email/Password Form */}
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="email" className="block text-sm font-semibold text-brand-slate mb-2">
                                Email address
                            </label>
                            <input
                                id="email"
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full px-4 py-3 border border-brand-border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all"
                                placeholder="you@example.com"
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-sm font-semibold text-brand-slate mb-2">
                                Password
                            </label>
                            <input
                                id="password"
                                type="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-3 border border-brand-border rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-transparent transition-all"
                                placeholder="••••••••"
                            />
                        </div>

                        <div className="flex items-center justify-between">
                            <label className="flex items-center gap-2 cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                    className="w-4 h-4 text-brand-blue border-brand-border rounded focus:ring-2 focus:ring-brand-blue"
                                />
                                <span className="text-sm text-slate-600">Remember me</span>
                            </label>
                            <a href="#" className="text-sm font-semibold text-brand-blue hover:underline">
                                Forgot password?
                            </a>
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full bg-brand-blue text-white px-4 py-3 rounded-lg font-semibold hover:bg-blue-600 transition-all shadow-lg shadow-blue-500/20 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {isLoading ? 'Signing in...' : 'Sign in'}
                        </button>
                    </form>

                    <p className="mt-8 text-center text-sm text-slate-500">
                        By signing in, you agree to our{' '}
                        <a href="#" className="text-brand-blue hover:underline">Terms of Service</a>
                        {' '}and{' '}
                        <a href="#" className="text-brand-blue hover:underline">Privacy Policy</a>
                    </p>
                </div>
            </div>
        </div>
    );
}
